import releaseSettings from "./releaseSettings.mjs";

export const defaultTemplateName = `Rubin (${releaseSettings.eShopVersion})`;
export const defaultThemeName = "Default";
export const defaultBannerNamePrefix = "mainBanner";
export const defaultMaxPrevSteps = 30;
export const defaultTemplateNameAbbreviation = "S";
export const defaultLinks = {
    b2c: "https://kreator-b2c.comarchesklep.pl/"
};
export const definedPages = {
    About: "config.DefinedPages.About.Id",
    AdvancedSearch: "config.DefinedPages.AdvancedSearch.Id",
    Blog: "config.DefinedPages.Blog.Id",
    BlogDetails: "config.DefinedPages.BlogDetails.Id",
    Brands: "config.DefinedPages.Brands.Id",
    Complaints: "config.DefinedPages.Complaints.Id",
    Contact: "config.DefinedPages.Contact.Id",
    CustomerProfile: "config.DefinedPages.CustomerProfile.Id",
    Home: "config.DefinedPages.Home.Id",
    Http404: "config.DefinedPages.Http404.Id",
    Login: "config.DefinedPages.Login.Id",
    Lookbook: "config.DefinedPages.Lookbook.Id",
    Loyalty: "config.DefinedPages.Loyalty.Id",
    Manufacturers: "config.DefinedPages.Manufacturers.Id",
    Order: "config.DefinedPages.Order.Id",
    PasswordReminder: "config.DefinedPages.PasswordReminder.Id",
    Payment: "config.DefinedPages.Payment.Id",
    Privacy: "config.DefinedPages.Privacy.Id",
    ProductComparisonTool: "config.DefinedPages.ProductComparisonTool.Id",
    ProductDetails: "config.DefinedPages.ProductDetails.Id",
    ProductList: "config.DefinedPages.ProductList.Id",
    Registration: "config.DefinedPages.Registration.Id",
    Shipping: "config.DefinedPages.Shipping.Id",
    Terms: "config.DefinedPages.Terms.Id",
    WithdrawalRight: "config.DefinedPages.WithdrawalRight.Id"
};